import { useEffect } from 'react'

// For removing Error displayed by virtuoso in ResizeObserver funtion
const useMonacoErrorHandler = () => {
  useEffect(() => {
    const errorMessages = [
      'ResizeObserver loop limit exceeded',
      'Script error.',
      'ResizeObserver loop completed with undelivered notifications.'
    ]

    const handleError = (e) => {
      if (errorMessages.includes(e.message)) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        )
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        )
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none')
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none')
        }
      }
    }

    window.addEventListener('error', handleError)

    return () => {
      window.removeEventListener('error', handleError)
    }
  }, [])
}

export default useMonacoErrorHandler
